import React from "react";
import { Box, Typography } from "@mui/material";
import { tokens } from "../../utils/figmaTokens";

// The Overview's stat strip (10697:16585): white cells on a 1 px grid line, a number over a
// small label; the Wallet card's balance is a strip of one. `value` is drawn as given. The
// Tutors overview (10967:74085) sets 8 px between the number and the label (`cellGap`).
const StatStrip = ({ items, cellGap = "2px" }) => (
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      gap: "1px",
      bgcolor: tokens.border.default,
      border: `1px solid ${tokens.border.default}`,
      borderRadius: "12px",
      overflow: "hidden",
    }}
  >
    {items.map((item) => (
      <Box
        key={item.key}
        sx={{ flex: "1 0 0", minWidth: 110, display: "flex", flexDirection: "column", gap: cellGap, px: "14px", py: "13px", bgcolor: tokens.surface.default }}
      >
        <Typography variant="titleMetric" sx={{ color: tokens.text.primary }}>
          {item.value}
        </Typography>
        <Typography variant="labelMicro" component="div" sx={{ color: tokens.text.tertiary }}>
          {item.label}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default StatStrip;
